export default __webpack_public_path__ + "img/logo.42883a2b.png";